<template>
  <mf-card-container class="mf-card-container-margin-top-24">
    <div data-userflow-id="step5">
      <span class="span-config-cupom-title">Configuração dos cupons</span>
      <span class="span-config-cupom-subtitle">Modelo de aplicação e tipo de desconto dos cupons.</span>
    </div>

    <div>
      <div class="options-container">
        <div v-for="(option, index) in options" :key="index" class="option-card-container">
          <v-card shaped :class="cardClasses(index)" @click="setDiscountType(option)">
            <div :class="divCardBGClass(index)">
              <v-img :src="option.icon" contain height="72" />
            </div>

            <span class="span-card-type">{{ option.type }}</span>
            <span class="span-card-title">{{ option.title }}</span>
            <span class="span-card-description">{{ option.description }}</span>
          </v-card>
        </div>
      </div>

      <hr class="hr-separator" />

      <template>
        <div class="container-step6" data-userflow-id="step6">
          <div class="div-flex-step6">
            <div class="div-flex-column-step6">
              <div>
                <span class="span-title-22-700-mb16">Valor do cupom de desconto</span>
                <span class="span-description-14-400-6b7580-380">
                  Informe o valor fixo do desconto que será concedido ao cliente. Esse valor será aplicado diretamente no cupom fiscal da compra.
                </span>
              </div>

              <div>
                <v-text-field
                  v-model.lazy="campaign.value"
                  v-money="money"
                  :error="validations.campaign.value && validations.campaign.value.$error"
                  :error-messages="errorValue"
                  prefix="R$"
                  outlined
                  class="v-text-field-value"
                  :maxlength="10"
                  label="Valor do cupom de desconto"
                  :disabled="disableFields"
                  @keydown="isNumber"
                />
              </div>
            </div>

            <div v-show="showMinimumPurchaseValueField" class="div-flex-column-step6">
              <div>
                <span class="span-title-22-700-mb16">Valor mínimo de compra</span>
                <span class="span-description-14-400-6b7580-380">
                  Defina o valor mínimo que o cupom fiscal deve atingir para que o desconto seja válido. É necessário que esse valor seja pelo menos o
                  <b>Valor de desconto + R$1.</b>
                </span>
              </div>

              <div>
                <v-text-field
                  v-model="campaign.minimumValue"
                  v-money="money"
                  prefix="R$"
                  outlined
                  class="v-text-field-value"
                  :maxlength="10"
                  label="Valor mínimo de compra"
                  :error="validations.campaign.minimumValue && validations.campaign.minimumValue.$error"
                  :error-messages="errorminimumValue"
                  :disabled="disableFields"
                  @keydown="isNumber"
                />
              </div>
            </div>

            <div v-show="showTriggerProductsValueField" class="div-flex-column-step6">
              <div>
                <span class="span-title-22-700-mb16">Valor mínimo de compra de produtos vigentes</span>
                <span class="span-description-14-400-6b7580-380">
                  Especifique o valor mínimo de compra considerando apenas os produtos participantes da promoção. É necessário que esse valor seja pelo menos o
                  <b>Valor de desconto + R$1.</b>
                </span>
              </div>

              <div>
                <v-text-field
                  v-model="campaign.minimumTriggerProductsValue"
                  v-money="money"
                  prefix="R$"
                  outlined
                  class="v-text-field-value"
                  :maxlength="10"
                  label="Valor mínimo de compra"
                  :error="validations.campaign.minimumTriggerProductsValue && validations.campaign.minimumTriggerProductsValue.$error"
                  :error-messages="errorMinimumTriggerProductsValue"
                  :disabled="disableFields"
                  @keydown="isNumber"
                />
              </div>
            </div>

            <div v-if="showTriggerProductsPurchaseValueField" class="div-flex-column-step6">
              <div>
                <span class="span-title-22-700-mb16">Quantidade mínima de produtos</span>
                <span class="span-description-14-400-6b7580-380">
                  Indique a quantidade mínima de produtos participantes que o cliente precisa comprar para que o desconto seja aplicado.
                </span>
              </div>

              <div>
                <mf-number-input
                  v-model="minimumProductsQuantity"
                  :disabled="disableFields"
                  outlined
                  label="Quantidade mínima de produtos"
                  :min="0"
                  :placeholder="1"
                  show-arrows
                  class="mf-number-input-298"
                  :error="validations.campaign.minimumProducts && validations.campaign.minimumProducts.$error"
                  :error-messages="errorMinimumProducts"
                />
              </div>
            </div>

            <div v-if="showTriggerProductsQuantityField" class="div-flex-column-step6">
              <div>
                <span class="span-title-22-700-mb16">Quantidade de produtos vigentes</span>
                <span class="span-description-14-400-6b7580-380">
                  Indique a quantidade mínima de produtos participantes que o cliente precisa comprar para que o desconto seja aplicado.
                </span>
              </div>

              <div>
                <mf-number-input
                  v-model="minimumTriggerProductsQuantity"
                  :disabled="disableFields"
                  outlined
                  label="Quantidade mínima de produtos"
                  :min="0"
                  :placeholder="1"
                  show-arrows
                  class="mf-number-input-298"
                  :error="validations.campaign.minimumProducts && validations.campaign.minimumProducts.$error"
                  :error-messages="errorMinimumProducts"
                />
              </div>
            </div>
          </div>

          <div class="div-max-desconto">
            <div class="div-flex-align-center">
              <mf-icon color="#0a8533" medium>payments</mf-icon>
              <span class="span-max-desconto">
                Máximo de desconto concedido:
                <span class="span-max-desconto-valor">{{ maximumDiscount }}</span>
              </span>
            </div>
            <span class="span-max-desconto-desc">
              O desconto previsto considera o valor do cupom e a segmentação escolhida, pois todos os clientes do grupo receberão o cupom na carteira ao acessar
              o app.
            </span>
          </div>

          <hr v-if="showProductsSelection" class="hr-separator-ecedf0" />

          <div v-if="showProductsSelection">
            <span class="span-title-22-700-mb24">Seleção de produtos vigentes</span>

            <div class="d-flex align-center justify-space-between">
              <span class="span-produtos-descricao">
                Com esta opção ativada, o cupom é válido apenas para compras que atendam a quantidade ou valor mínimo dos produtos selecionados. <br />
                Compras sem esses produtos não poderão usar o cupom. Se desabilitada, não haverá regras de produtos para a campanha.
              </span>

              <modal-graphql-search-content
                button-activator
                hide-csv-upload
                return-groups
                button-text="Selecionar produtos"
                :selected-items.sync="campaign.products"
                :is-segmentation="false"
                :disabled="disableFields"
                @confirm="insertProducts"
              />
            </div>

            <div v-if="showUngroupedTable">
              <coupon-discount-products-table
                class="mt-4"
                :products="ungroupedProducts"
                :validations="validations"
                :disabled="disableFields"
                @remove-item="removeItem"
              />
            </div>

            <div v-if="showGroupedTable" class="mt-8">
              <h2 class="mb-0">Grupos de produtos</h2>

              <div v-for="group in groupedProducts" :key="group._id">
                <hr class="my-4" />
                <div class="d-flex align-center justify-space-between">
                  <h2>{{ group.name }}</h2>
                  <mf-button
                    text
                    color="vermelho-d20"
                    :disabled="group.disabled || disableFields"
                    label="Remover grupo"
                    icon="delete"
                    @click="removeGroup(group._id)"
                  />
                </div>
                <coupon-discount-products-table
                  class="mt-4"
                  :products="group.products"
                  :validations="validations"
                  :showDeleteProductIcon="getCheckShowDeleteProductIcon"
                  @remove-item="removeItemFromGroup($event, group._id)"
                />
              </div>
            </div>
          </div>
        </div>
      </template>
    </div>
  </mf-card-container>
</template>

<script>
import findIndex from 'lodash/findIndex'
import { VMoney } from 'v-money'
import { mapGetters } from 'vuex'

export default {
  name: 'CouponDiscountType',
  directives: { money: VMoney },
  components: {
    ModalGraphqlSearchContent: () => import('@/components/ModalGraphqlSearchContent.vue'),
    CouponDiscountProductsTable: () => import('./CouponDiscountProductsTable.vue'),
  },
  props: {
    campaign: {
      type: Object,
      default: () => {},
    },
    segmented: {
      type: Boolean,
      default: true,
    },
    validations: {
      type: Object,
      default: () => {},
    },
  },
  data() {
    return {
      selectedOption: 0,
      minimumProductsQuantity: this.campaign.minimumProducts,
      minimumTriggerProductsQuantity: this.campaign.minimumProducts,
      money: {
        decimal: ',',
        thousands: '.',
        precision: 2,
        masked: false,
      },
      options: [
        {
          type: 'Sem produtos vigentes',
          title: 'Valor de compra',
          description: 'É preciso atingir o valor mínimo de compra para usar o cupom.',
          icon: './static/img/valor-total-cupom.svg',
          value: 'NO_TRIGGER_PRODUCTS',
        },
        {
          type: 'Com produtos vigentes',
          title: 'Valor de compra + produtos participantes',
          description: 'É preciso atingir o valor mínimo e incluir uma quantidade de produtos para usar o cupom.',
          icon: './static/img/valor-compra-item-selecionado.svg',
          value: 'TRIGGER_PRODUCTS_PURCHASE_VALUE',
        },
        {
          type: 'Com produtos vigentes',
          title: 'Quantidade de produtos',
          description: 'É preciso adquirir a quantidade mínima de produtos participantes para usar o cupom.',
          icon: './static/img/quantidade-items.svg',
          value: 'TRIGGER_PRODUCTS_QUANTITY',
        },
        {
          type: 'Com produtos vigentes',
          title: 'Valor de compra em produtos participantes',
          description: 'É preciso atingir o valor mínimo em produtos participantes para usar o cupom.',
          icon: './static/img/valor-items-selecionados.svg',
          value: 'TRIGGER_PRODUCTS_VALUE',
        },
      ],
    }
  },
  computed: {
    ...mapGetters(['getTotalClientesSegmento']),

    cardClasses() {
      return (index) => {
        const classes = ['v-card-base']
        if (this.selectedOption === index) classes.push('v-card-selected')
        if (this.disableFields && this.selectedOption !== index) {
          classes.push('v-card-disabled-other')
        }
        return classes
      }
    },

    divCardBGClass() {
      return (index) => {
        if (this.selectedOption === index) {
          return ['div-card-padding', 'div-card-bg-selected']
        } else if (this.disableFields && this.selectedOption !== index) {
          return ['div-card-padding', 'div-card-bg-inherit']
        }
        return ['div-card-padding', 'div-card-bg-default']
      }
    },

    showGroupedTable() {
      return this.groupedProducts.length > 0
    },
    showUngroupedTable() {
      return this.ungroupedProducts.length > 0 || this.groupedProducts.length === 0
    },
    disableFields() {
      return ['FINISHED', 'ACTIVE'].includes(this.campaign.status)
    },
    getCheckShowDeleteProductIcon() {
      return !['FINISHED', 'ACTIVE'].includes(this.campaign.status)
    },
    ungroupedProducts() {
      return (this.campaign.products || []).filter((product) => !product.isGroup)
    },
    groupedProducts() {
      return (this.campaign.products || []).filter((product) => product.isGroup)
    },
    showMinimumPurchaseValueField() {
      return ['NO_TRIGGER_PRODUCTS', 'TRIGGER_PRODUCTS_PURCHASE_VALUE'].includes(this.campaign.promoType)
    },
    showTriggerProductsValueField() {
      return this.campaign.promoType === 'TRIGGER_PRODUCTS_VALUE'
    },
    showTriggerProductsPurchaseValueField() {
      return this.campaign.promoType === 'TRIGGER_PRODUCTS_PURCHASE_VALUE'
    },
    showTriggerProductsQuantityField() {
      return this.campaign.promoType === 'TRIGGER_PRODUCTS_QUANTITY'
    },
    showProductsSelection() {
      return this.campaign.promoType !== 'NO_TRIGGER_PRODUCTS'
    },
    errorValue() {
      if (!this.validations.campaign.value) return ''
      if (this.validations.campaign.value.$error) {
        if (!this.validations.campaign.value.required) return 'Insira o valor do cupom de desconto.'
        else if (!this.validations.campaign.value.minValue) return 'O valor deve ser no mínimo R$1,00.'
      }
      return ''
    },
    errorminimumValue() {
      if (!this.validations.campaign.minimumValue) return ''
      if (this.validations.campaign.minimumValue.$error) {
        if (!this.validations.campaign.minimumValue.required) return 'Insira o valor mínimo de compra'
        else if (!this.validations.campaign.minimumValue.minValue) return 'O valor deve ser no mínimo R$1,00 a mais que o cupom de desconto.'
      }
      return ''
    },
    errorMinimumProducts() {
      if (!this.validations.campaign.minimumProducts) return ''
      if (this.validations.campaign.minimumProducts.$error) {
        if (!this.validations.campaign.minimumProducts.required) return 'Insira a quantidade mínima de produtos'
        else if (!this.validations.campaign.minimumProducts.minValue) return 'Insira um valor maior que 0.'
      }
      return ''
    },
    errorMinimumTriggerProductsValue() {
      if (!this.validations.campaign.minimumTriggerProductsValue) return ''
      if (this.validations.campaign.minimumTriggerProductsValue.$error) {
        if (!this.validations.campaign.minimumTriggerProductsValue.required) {
          return 'Insira o valor mínimo de compra de produtos vigentes.'
        } else if (!this.validations.campaign.minimumTriggerProductsValue.minValue) {
          return 'O valor deve ser no mínimo R$1,00 a mais que o valor do cupom de desconto.'
        }
      }
      return ''
    },
    maximumDiscount() {
      const parseNumber = (value) => {
        return parseFloat(value.toString().replace(/\./g, '').replace(',', '.'))
      }
      if (this.segmented) {
        const fallbackClients = Number(this.campaign.segmentsData?.[0]?.clientsQty) || 0
        const totalRaw = Number(this.getTotalClientesSegmento)
        const clientsTotal = isNaN(totalRaw) || totalRaw <= 0 ? fallbackClients : totalRaw
        const campaignValue = parseNumber(this.campaign.value)
        const value = isNaN(campaignValue) ? 0 : campaignValue
        return `R$ ${(value * clientsTotal).toLocaleString('pt-BR', {
          minimumFractionDigits: 2,
          maximumFractionDigits: 2,
        })}`
      } else {
        const campaignValue = parseNumber(this.campaign.value)
        return `R$ ${(campaignValue * this.campaign.limitUse).toLocaleString('pt-BR', {
          minimumFractionDigits: 2,
          maximumFractionDigits: 2,
        })}`
      }
    },
  },
  watch: {
    'campaign.promoType': {
      handler(newVal, oldVal) {
        const foundIndex = this.options.findIndex((opt) => opt.value === newVal)
        this.selectedOption = foundIndex !== -1 ? foundIndex : 0
      },
      immediate: true,
    },
    minimumProductsQuantity(val) {
      this.campaign.minimumProducts = val
    },
    minimumTriggerProductsQuantity(val) {
      this.campaign.minimumProducts = val
    },
  },
  methods: {
    isNumber(evt) {
      const charCode = evt.which ? evt.which : evt.keyCode
      if (charCode > 31 && (charCode < 48 || charCode > 57) && charCode !== 46 && !(charCode >= 96 && charCode <= 105)) {
        evt.preventDefault()
      }
    },
    insertProducts(groupProducts) {
      if (!groupProducts) return
      let clonedProducts = []

      groupProducts.forEach((product, index) => {
        const productIndex = findIndex(this.campaign.products, (clonedProduct) => {
          return (clonedProduct._id && clonedProduct._id === product._id) || (clonedProduct.sku && clonedProduct.sku === product.sku)
        })
        if (productIndex >= 0) {
          let newProduct = {}
          if (product.products) {
            const { products, imported, ...groupWithoutProducts } = this.campaign.products[productIndex]
            newProduct = Object.assign(this.formatProduct(product, index, imported), groupWithoutProducts)
          } else {
            const isImported = false
            newProduct = Object.assign(this.formatProduct(product, index, isImported), this.campaign.products[productIndex])
          }
          clonedProducts.push(newProduct)
        } else {
          const isImported = false
          clonedProducts.push(Object.assign(this.formatProduct(product, index, isImported)))
        }
      })
      this.campaign.products = [...clonedProducts]
    },
    formatProduct(product, index, isImported) {
      let newProduct = {}
      if (product.products) {
        const formattedProducts = product.products.map((item) => {
          return {
            isGroup: true,
            imported: isImported,
            disabled: this.isDisabledProduct(isImported),
            sku: item.sku,
            ean: item.ean,
            _id: item._id,
            eans: item.eans.length === 1 ? [item.ean] : item.eans,
            name: item.name,
            origin: 'search',
            original_eans: item.product?.eans ? item.product.eans : [],
            image_url: item.image_url || item.image,
            product: item.product
              ? item.product
              : {
                  image_url: item.image,
                  ean: item.ean,
                  eans: item.eans.length > 1 ? item.eans : [item.ean],
                },
            index,
          }
        })
        newProduct = Object.assign(
          {
            _id: product._id,
            isGroup: true,
            imported: isImported,
            disabled: this.isDisabledProduct(isImported),
            name: product.name,
            products: formattedProducts,
            group_image_url: product.image_url,
            categories_final_consumer: product.categories_final_consumer,
            index,
          },
          this.productsExtraFieldsInfo
        )
      } else {
        newProduct = Object.assign(
          {
            _id: product._id,
            imported: isImported,
            disabled: this.isDisabledProduct(isImported),
            active: typeof product.active === 'boolean' ? product.active : true,
            sku: product.sku,
            ean: product.ean,
            eans: product?.eans?.length === 1 ? [product.ean] : product.eans,
            name: product.name,
            image_url: product.image_url || product.image,
            product: {
              image: product.image,
              ean: product.ean,
              eans: product.eans.length > 1 ? product.eans : [product.ean],
            },
            index,
          },
          this.productsExtraFieldsInfo
        )
      }
      return newProduct
    },
    isDisabledProduct(isImported) {
      return (
        this.campaign.status === 'finished' ||
        this.campaign.status === 'expired' ||
        this.campaign.status === 'industry_rejected' ||
        this.campaign.status === 'processing' ||
        ((this.campaign.status === 'active' || this.campaign.status === 'scheduled') && !isImported)
      )
    },
    removeItem(item) {
      const newProducts = this.campaign.products
        .map((offer) => {
          if (offer.sku !== item.sku) return offer
        })
        .filter((item) => item)
      this.campaign.products = newProducts
    },
    removeItemFromGroup(item, groupId) {
      const newProducts = this.campaign.products.map((offer) => {
        if (offer._id === groupId) {
          return {
            ...offer,
            products: offer.products
              .map((product) => {
                if (product.sku !== item.sku) return product
              })
              .filter((item) => item),
          }
        }
        return offer
      })
      this.campaign.products = newProducts
    },
    removeGroup(groupId) {
      const newProducts = this.campaign.products
        .map((offer) => {
          if (offer._id !== groupId) return offer
        })
        .filter((item) => item)
      this.campaign.products = newProducts
    },
    setDiscountType(item) {
      if (this.disableFields) return
      this.selectedOption = findIndex(this.options, (option) => option.value === item.value)
      this.campaign.promoType = item.value
    },
  },
}
</script>

<style lang="scss" scoped>
.mf-card-container-margin-top-24 {
  margin-top: 24px;
}

.span-config-cupom-title {
  display: block;
  font-size: 22px;
  font-weight: 700;
  color: #4b525a;
  margin-bottom: 8px;
}

.span-config-cupom-subtitle {
  display: block;
  font-size: 16px;
  font-weight: 400;
  color: #6b7580;
}

.hr-separator {
  border: none;
  border-top: 1px solid #ecedf0;
  margin-bottom: 24px;
}

.options-container {
  margin: 24px 0;
  display: flex;
  flex-wrap: wrap;
  gap: 16px;
  align-items: stretch;
}

.option-card-container {
  flex: 1 1 280px;
  max-width: 100%;
  display: flex;
}

.option-card-container > .v-card {
  height: 100%;
  width: 100%;
  display: flex;
  flex-direction: column;
}

@media (min-width: 1200px) {
  .option-card-container {
    flex: 0 0 calc((100% - 48px) / 4);
    max-width: calc((100% - 48px) / 4);
  }
}

:deep(.v-card-base) {
  border-radius: 16px;
  transition: 0.3s;
  min-height: 280px;
  flex: 1 1 auto;
  height: 100%;
  display: flex;
  flex-direction: column;
  cursor: pointer;
  overflow: visible;
}

:deep(.v-card-selected) {
  border: 2px solid #1976d2 !important;
}

:deep(.v-card-disabled-other) {
  cursor: default !important;
  pointer-events: none;
  opacity: 0.6;
  box-shadow: inherit;
}

.div-card-padding {
  padding: 32px 0px;
}

.div-card-bg-selected {
  background-color: #e3f2fd;
}

.div-card-bg-default {
  background-color: #f5f5f5;
}

.div-card-bg-inherit {
  background-color: inherit;
}

.span-card-type {
  display: block;
  font-size: 14px;
  font-weight: 700;
  color: #31363b;
  padding: 8px 12px;
  background-color: #ecedf0;
}

.span-card-title {
  display: block;
  font-size: 14px;
  font-weight: 700;
  color: #4b525a;
  margin-top: 8px;
  margin-bottom: 4px;
  padding-left: 12px;
  padding-right: 12px;
}

.span-card-description {
  display: block;
  font-size: 12px;
  font-weight: 400;
  color: #6b7580;
  padding: 0 12px 12px 12px;
  margin-right: 24px;
}

.container-step6 {
  margin-top: 24px;
}

.div-flex-step6 {
  display: flex;
  flex: 1;
}

.div-flex-column-step6 {
  flex: 1;
  display: flex;
  flex-direction: column;
  justify-content: space-between;
}

.span-title-22-700-mb16 {
  display: block;
  font-size: 22px;
  font-weight: 700;
  color: #4b525a;
  margin-bottom: 16px;
}

.span-description-14-400-6b7580-380 {
  display: block;
  font-size: 14px;
  font-weight: 400;
  color: #6b7580;
  width: 340px;
}

.v-text-field-value {
  margin-top: 24px !important;
  width: 298px !important;
}

.mf-number-input-298 {
  margin-top: 24px !important;
  width: 298px !important;
}

.div-max-desconto {
  background-color: #f6f6f8;
  border-radius: 8px;
  padding: 10px 12px;
  margin-top: 24px;
}

.div-flex-align-center {
  display: flex;
  align-items: center;
}

.span-max-desconto {
  margin-left: 8px;
  font-weight: 600;
  font-size: 16px;
  color: #4b525a;
}

.span-max-desconto-valor {
  font-size: 16px;
  font-weight: 600;
  color: #0a8533;
}

.span-max-desconto-desc {
  display: block;
  font-size: 14px;
  font-weight: 400;
  color: #6b7580;
  margin-top: 8px;
}

.hr-separator-ecedf0 {
  border: none;
  border-top: 1px solid #ecedf0;
  margin: 24px 0px;
}

.span-title-22-700-mb24 {
  display: block;
  font-size: 22px;
  font-weight: 700;
  color: #4b525a;
  margin-bottom: 24px;
}

.span-produtos-descricao {
  display: block;
  font-size: 14px;
  font-weight: 400;
  color: #6b7580;
}

@media (max-width: 850px) {
  .div-flex-step6 {
    flex-direction: column;
    align-items: flex-start;
  }

  .div-flex-column-step6 {
    width: 100%;
    align-items: flex-start;
    text-align: left;
  }

  .v-text-field-value,
  .mf-number-input-298 {
    width: 100% !important;
    max-width: 298px;
  }

  .span-description-14-400-6b7580-380 {
    width: 100%;
    max-width: 340px;
  }
}
</style>
